import React from 'react';

import {AlignmentSummary} from 'constants/AlignmentConstants';
import BaseListingRendererWithPlugins from 'nav/expanded/BaseListingRendererWithPlugins';
import {
  ColumnAccessorKey,
  ColumnConfiguration,
  ListingRendererType,
} from 'nav/expanded/ListingRendererConstants';
import {AlignmentSidepanelTitle} from 'nav/sidepanel/listing/AlignmentSidepanelItem';
import {SortKey} from 'search/SearchConstants';
import {getColumnHeaderFromSortKey} from 'search/SortUtil';
import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {TABLE_ROW_BODY_HEIGHT} from 'ui-library/scrollable/ScrollableTableConstants';
import * as DateUtil from 'util/DateUtil';

export default class AlignmentListingRenderer extends BaseListingRendererWithPlugins<ListingRendererType.ALIGNMENT> {
  listingRendererType = ListingRendererType.ALIGNMENT;

  getNonPluginColumnConfigurations(): Array<ColumnConfiguration<AlignmentSummary>> {
    return [
      {
        column: {
          header: getColumnHeaderFromSortKey(SortKey.SORT_NAME_KEY),
          accessorKey: ColumnAccessorKey.NAME,
          flexGrow: 1,
          isSortable: true,
          sortKey: SortKey.SORT_NAME_KEY,
        },
        render: (alignmentSummary: AlignmentSummary) => (
          <AlignmentSidepanelTitle alignmentSummary={alignmentSummary} />
        ),
      },
      {
        column: {
          header: getColumnHeaderFromSortKey(SortKey.SORT_MODIFIED_AT_KEY),
          accessorKey: ColumnAccessorKey.MODIFIED_AT,
          flexGrow: 1,
          isSortable: true,
          sortKey: SortKey.SORT_MODIFIED_AT_KEY,
        },
        render: (alignmentSummary: AlignmentSummary) => (
          <Tooltip
            title={DateUtil.readableTime(alignmentSummary.modifiedAt, {showTime: true})}
            container="body"
            placement={TooltipPlacement.TOP}
            delay={350}
          >
            <span className="u-ellipsis-text">
              {DateUtil.readableTime(alignmentSummary.modifiedAt, {showTime: false})}
            </span>
          </Tooltip>
        ),
      },
      {
        column: {
          header: getColumnHeaderFromSortKey(SortKey.SORT_CREATED_AT_KEY),
          accessorKey: ColumnAccessorKey.CREATED_AT,
          flexGrow: 1,
          isSortable: true,
          sortKey: SortKey.SORT_CREATED_AT_KEY,
        },
        render: (alignmentSummary: AlignmentSummary) => (
          <Tooltip
            title={DateUtil.readableTime(alignmentSummary.createdAt, {showTime: true})}
            container="body"
            placement={TooltipPlacement.TOP}
            delay={350}
          >
            <span className="u-ellipsis-text">
              {DateUtil.readableTime(alignmentSummary.createdAt, {showTime: false})}
            </span>
          </Tooltip>
        ),
      },
    ];
  }

  getNonPluginRowContentHeight(): number {
    return TABLE_ROW_BODY_HEIGHT;
  }

  renderIcon(): JSX.Element {
    return <BenchlingIcon className="scrollableTable-cell-icon" icon="alignment" />;
  }

  openContextMenu(): void {}
}
